var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoRepaired(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    width: "45px",
    height: "45px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#FFEB3B;}\r\n\t.st2{display:inline;}\r\n\t.st3{fill:#1D1D1B;stroke:#1D1D1B;stroke-width:0.75;stroke-miterlimit:10;}\r\n\t.st4{fill:#FFFFFF;stroke:#1D1D1B;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st5{fill:#546E7A;}\r\n\t.st6{fill:none;stroke:#1D1D1B;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st7{fill:#1D1D1B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_3",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.6,
    y: 6.4,
    className: "st1",
    width: 25.3,
    height: 17.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Livello_46",
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.9,10.4c0-1.1-0.9-2-1.9-2s-2,0.9-2,2s0.9,1.9,1.9,1.9S7.9,11.4,7.9,10.4 M3.5,22.5 C3.5,22.5,3.4,22.5,3.5,22.5l23.1,0.1l0,0l-7.9-10.8c0,0-0.9-1.3-1.9,0l-4.9,6.7L10.1,16c0,0-0.9-1.3-1.9,0L3.5,22.5z M27.4,23.3 H2.6V6.7h24.7L27.4,23.3L27.4,23.3z M28.4,23.8V6.2c0-0.3-0.2-0.5-0.5-0.5H2.1c-0.3,0-0.5,0.2-0.5,0.5v17.6c0,0.3,0.2,0.5,0.5,0.5 h25.8C28.2,24.3,28.4,24.1,28.4,23.8"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 2.7,
    className: "st4",
    width: 28,
    height: 24.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.4,
    y: 4.9,
    className: "st5",
    width: 22.9,
    height: 16.6
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "3.1,8.4 3.1,4.9 26.8,4.9 26.8,16.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "3.1,10.3 3.1,21.5 26.8,21.5 26.8,18.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "3.1,17 3.1,21.1 26.5,21.1 9.8,12.5 7.6,12.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "9,12.9 8.8,12.4 8.5,12.4 8.6,12.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "9.4,13.9 9.2,13.3 8.7,13.3 8.9,13.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "9.6,14.3 9.9,15.1 9.2,15.1 9,14.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "10.2,15.8 10.9,17.5 9.9,17.5 9.4,15.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "11.3,18.6 12.3,21.1 10.9,21.1 10.2,18.6  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoRepaired);
export default __webpack_public_path__ + "static/media/photo_repaired.d9416c915d14d77c7e480d52d6821e89.svg";
export { ForwardRef as ReactComponent };